import React, {Component} from 'react';
import {injectStripe} from 'react-stripe-elements';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import AppointmentService from '../utils/AppointmentService.js';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import {CardElement} from 'react-stripe-elements'
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

const override = css`
    display: block;
    margin: 1% 1%;
    border-color: red;
`;
export class NewCCForm extends Component {
  constructor(props) {
    super(props)
    this.state ={
      ccNumber: '',
      expMonth: '',
      expYear: '',
      cvc:'',
      cardName:'',
      ccError: '',
      formError: this.props.ccErrors,
      isLoading: false,
      billingZipcode: '',
      showForm: true
    }
    this.Appt = new AppointmentService()
    this.saveCard = this.saveCard.bind(this)
    this.handleMonthChange = this.handleMonthChange.bind(this)
    this.saveCardIdToConductor = this.saveCardIdToConductor.bind(this)
    this.stripeInputChange = this.stripeInputChange.bind(this)
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.ccErrors){
      this.setState({
        formError: nextProps.ccErrors
      })
    }
  }
  handleChange = name => event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }

  handleMonthChange = month => {
      this.setState({
        expMonth: month.value
      });
  }
  saveCard = (event) => {
    var this2 = this
    document.getElementById("saveCardButton").setAttribute('disabled', 'disabled');
    event.preventDefault()
    if(this.state.cardName && this.state.cardName.length > 0){
    //both of these allow you to create cards. CreateToken is not even registering that I am sending the customer_id
    this.props.stripe
      .createToken({type: 'card', name: this.state.cardName})
      .then (result=> {
        if(result.token){
          this.setState({
            isLoading:true,
            formError: "",
            showForm: false
          })
          this.saveCardIdToConductor(result.token.id)
          }
        })
      .catch((err)=> {
        throw new Error ("ERROR creating token: "+ err)
      });
    }
    else {
      document.getElementById("saveCardButton").removeAttribute('disabled');
      this.setState({
        formError: "Name is required",
        showForm: true
      })
    }

  }
  stripeInputChange(){
      document.getElementById("saveCardButton").removeAttribute('disabled');
  }
  saveCardIdToConductor(paymentID){
   if(this.props.onLoad){
       //this.props.onLoad()
    }
    this.Appt.addCreditCardByStripeID(paymentID)
    .then(res => {
      if(res.errors){
        this.setState({
          formError: res.errors,
          showForm: true,
          isLoading:false
        })
      }
      else{
        if(this.props.onLoad){
            this.props.onLoad()
        }
        this.setState({
          isLoading:false
        })
        if(this.props.afterSave){
          this.props.afterSave()
        }
        this.props.closeModal()
      }
    })
    .catch(err => {
      this.setState({
        errorMessage: "Error Saving Credit Card"
      })
      throw new Error("Error saving card: " + err)
    })
  }
  render() {
    var elementStyles = {
      base: {
        color: '#32325D',
        'margin-top': '10px;',
        'padding-bottom': '10px;',
        fontWeight: 500,
        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
        fontSize: '16px',
        border: 'none',
        'box-shadow': 'none',
        'border-bottom': '5px solid red',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#CFD7DF',
        },
        ':-webkit-autofill': {
          color: '#e39f48',
        },
      },
      invalid: {
        color: '#E25950',

        '::placeholder': {
          color: '#FFCCA5',
        },
      },
    };
    return (
      <div>
        { this.state.showForm &&
        <form className="ccForm" onSubmit={this.saveCard}>
        <p className="errorMessage">{this.state.formError}</p>
          <CardElement
            style={elementStyles}
            onChange={this.stripeInputChange}/>
           <input id="cardName" type="text" placeholder = "Name on Card" value={this.state.cardName} onChange={this.handleChange('cardName')} />
          <div className = "bottomButtons">
            <button id="saveCardButton" className="btn successButtonFlex btn-block text-center" type="submit">Save Card</button>
            <button onClick = {() => this.props.closeModal()}className="btn btn-block cancelButtonFlex text-center">Cancel</button>
          </div>

        </form>
      }
      <ClipLoader
        className={override}
        sizeUnit={"px"}
        size={100}
        color={'#164070'}
        loading={this.state.isLoading}
      />
      </div>
    )
  }
}
export default injectStripe(NewCCForm)



// WEBPACK FOOTER //
// ./src/Components/InjectedCCForm.js